"use client";

import { motion } from "framer-motion";
export default function GlobalNetwork() {
  return;
}